import {SigplaniModuloEnum} from '../enum/sigplani-modulo.enum';
import { EmpresaVO } from './empresa-vo.model';
import { UsuarioAutenticado } from './usuario-autenticado.model';
import { Instituicao } from './instituicao.model';
import { AnoBase, RdaAutenticado, SelecionaEntidadeVO } from '.';

export class UsuarioSessao {
  usuario: UsuarioAutenticado;
  empresa: EmpresaVO;
  rdaAutenticado: RdaAutenticado
  instituicao: Instituicao;
  anoBase: AnoBase;
  entidadeSelecionada: SelecionaEntidadeVO;
  gerenciamento: boolean;
  modulo: SigplaniModuloEnum;
}
